import * as React from 'react'
import { TooltipWrapper } from 'uiComponents/tooltip.new/tooltipWrapper'
import { LucideIcon } from 'utils/lucideIcon'
import { OnSaleFactorLine } from 'capacity/domain/onSale'
import { useTranslation } from 'translations'

export function OnSaleCell({ factors }: { factors: OnSaleFactorLine[] | null }) {
    const { t } = useTranslation()
    if (!factors) {
        return (
            <TooltipWrapper
                text={t('capacity.products.onSale.optionTooltip')}
                arrowPosition="right"
                className="capacity-tip capacity-on-sale-tip"
                revealOnFocus
            >
                <span className="capacity-on-sale-value muted" tabIndex={0}>
                    —
                </span>
            </TooltipWrapper>
        )
    }
    const onSale = factors.every((factor) => factor.met)
    return (
        <TooltipWrapper
            arrowPosition="right"
            className="capacity-tip capacity-on-sale-tip"
            revealOnFocus
            content={
                <ul className="capacity-on-sale-factors">
                    {factors.map((factor) => (
                        <li key={factor.key} className={factor.met ? 'met' : 'not-met'}>
                            <span className="capacity-on-sale-factor-icon" aria-hidden="true">
                                <LucideIcon iconName={factor.met ? 'Check' : 'X'} size={14} strokeWidth={2} />
                            </span>
                            <span className="capacity-on-sale-factor-text">
                                <span>{factor.label}</span>
                                {factor.detail && (
                                    <span className="capacity-on-sale-factor-detail">{factor.detail}</span>
                                )}
                            </span>
                        </li>
                    ))}
                </ul>
            }
        >
            <span className="capacity-on-sale-value" tabIndex={0}>
                {onSale ? t('capacity.products.onSale.yes') : t('capacity.products.onSale.no')}
            </span>
        </TooltipWrapper>
    )
}
